import script from "./AISettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AISettings.vue?vue&type=script&setup=true&lang=js"

import "./AISettings.vue?vue&type=style&index=0&id=1d507c3a&lang=css"

const __exports__ = script;

export default __exports__